import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import omit from "lodash/omit";

import { sessionPackQueryKeys } from "./sessionPackQueryKeys";

export function useSessionPackCreate({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      newSessionPack: Parameters<ApiType["creditPackApi"]["create"]>[0],
    ) => {
      return (
        await api.creditPackApi.create(
          omit(newSessionPack, "termsConditions"),
          newSessionPack["termsConditions"],
        )
      ).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sessionPackQueryKeys.all() });
    },
  });
}
